import $ from 'jquery';
import SubNavbar from '../../../components/sub-navbar';
$(() => {
    SubNavbar.init();
});
